export default __webpack_public_path__ + "static/rsaf-fbbfbcccc582941ff5f7220851d7ca16.png";